import { TournamentsApi, useApiQuery, type APIQueryOptions } from "@xs2event/js-lib/api";

const tournamentsApi = new TournamentsApi();

/**
 * Every upcoming tournament (date_stop >= today), filtered to the calling distributor's sports.
 * Takes no filters and no pagination — the portal filters client side.
 */
/** How long the search menu treats the tournaments cache as fresh, the same as the events cache. */
export const PORTAL_TOURNAMENTS_CACHE_STALE_TIME = 1000 * 60 * 30; // 30 minutes

export const usePortalTournamentsCache = (options?: APIQueryOptions) =>
  useApiQuery(tournamentsApi, "tournamentsportalcacheGet", undefined, { debounce: false, ...options });
